import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { ISoftionState } from '../types'

export default combineReducers<ISoftionState['communications']>({
  getBetHistory: makeCommunicationReducer(actions.getBetHistory),
  cancelTicket: makeCommunicationReducer(actions.cancelTicket),
  getSubBet: makeCommunicationReducer(actions.getSubBet),
  createSession: makeCommunicationReducer(actions.createSession),
  clearSession: makeCommunicationReducer(actions.clearSession),
})
